import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Table, TableHead, TableBody, TableRow, TableCell, IconButton, Icon, Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from '@material-ui/core';

import { daysOfWeek } from '../../models';
import convertBinaryToDays from '../../util/convert-binary-to-days';


const cols = [
  'Lokal',
  'Report',
  'Häufigkeit',
  'Nächster Report',
  'Uhrzeit',
  'Zeitraum',
  '',
];

const styles = {
  deleteButton: {
    padding: 0,
  },
  firstCell: {
    paddingLeft: 0,
  },
  lastCell: {
    paddingRight: 0,
  },
  header: {
    fontWeight: 600,
  },
  wrapper: {
    paddingBottom: 10,
  },
  selectedRow: {
    backgroundColor: '#e0e0e0',
  },
};

class EmailReportsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailReportToDelete: null,
    };
  }

  handleDeleteClose = () => this.setState({ emailReportToDelete: null });

  handleDeleteConfirm = () => {
    const { deleteEmailReport } = this.props;
    const { emailReportToDelete } = this.state;

    deleteEmailReport(emailReportToDelete);
    this.handleDeleteClose();
  }

  renderNextSendout = (row) => {
    const { frequencies } = this.props;
    const frequency = frequencies.find(f => f.id === row.frequency);

    if (frequency.showWeekdays) {
      const days = convertBinaryToDays(row.interval);

      return days.map(day => daysOfWeek[day - 1].name).join(', ');
    }

    return row.nextSendout ? moment(row.nextSendout).format('D.M.Y') : '-';
  };

  renderPeriod = (duration) => {
    const { periods } = this.props;

    const period = periods.find(p => p.duration === duration);
    return period ? period.name : 'Unbekannter Zeitraum';
  }

  renderRow = (row) => {
    const {
      frequencies, reports, locations, selectEmailReportForEdit, selectedEmailReport,
    } = this.props;
    const config = JSON.parse(row.config);

    const location = locations.find(l => l.id === config.LocationId);
    const report = reports.find(r => r.reportID === config.ReportId);

    const selected = row.scheduleId === selectedEmailReport;

    return (
      <TableRow key={row.scheduleId} selected={selected} style={selected ? styles.selectedRow : null}>
        <TableCell style={styles.firstCell}>
          {location ? location.name : 'Unbekanntes Lokal'}
        </TableCell>
        <TableCell>
          {report ? report.name : 'Unbekannter Bericht'}
        </TableCell>
        <TableCell>
          {frequencies.find(f => f.id === row.frequency).name}
        </TableCell>
        <TableCell>
          {this.renderNextSendout(row)}
        </TableCell>
        <TableCell>
          {row.sendoutTime.substring(0, 5)}
        </TableCell>
        <TableCell>
          {this.renderPeriod(config.Duration)}
        </TableCell>
        <TableCell style={styles.lastCell}>
          <IconButton style={styles.deleteButton} onClick={() => selectEmailReportForEdit(row.scheduleId)}>
            <Icon>edit</Icon>
          </IconButton>
          <IconButton style={styles.deleteButton} onClick={() => this.setState({ emailReportToDelete: row.scheduleId })}>
            <Icon>delete</Icon>
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  renderDeleteEmailReportDialog = () => {
    const { emailReportToDelete } = this.state;

    return (
      <Dialog
        open={!!emailReportToDelete}
        onClose={this.handleDeleteClose}
      >
        <DialogTitle>E-Mail Report löschen</DialogTitle>
        <DialogContent>Wollen Sie diesen E-Mail Report wirklich löschen?</DialogContent>
        <DialogActions>
          <Button onClick={this.handleDeleteClose} color="primary">
            Abbrechen
          </Button>
          <Button onClick={this.handleDeleteConfirm} color="primary" autoFocus>
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { data } = this.props;

    return (
      <div style={styles.wrapper}>
        <h3>Aktive E-Mail Reports</h3>
        <Table size="small">
          <TableHead>
            <TableRow style={{ fontWeight: 600 }}>
              {cols.map((col, i) => (
                <TableCell
                  key={col}
                  style={i === 0 ? { ...styles.firstCell, ...styles.header } : styles.header}
                >
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(this.renderRow)}
          </TableBody>
          {this.renderDeleteEmailReportDialog()}
        </Table>
      </div>
    );
  }
}

EmailReportsTable.propTypes = {
  data: PropTypes.array.isRequired,
  frequencies: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  periods: PropTypes.array.isRequired,
  reports: PropTypes.array.isRequired,
  selectedEmailReport: PropTypes.number,
  deleteEmailReport: PropTypes.func.isRequired,
  selectEmailReportForEdit: PropTypes.func.isRequired,
};

EmailReportsTable.defaultProps = {
  selectedEmailReport: null,
};

export default EmailReportsTable;
